// extracted by mini-css-extract-plugin
module.exports = {"clock":"clock_clock__iIOv8"};